import {Injectable} from '@angular/core';
import {DataService} from './data.service';
import {AdminPermission} from '../models/admin-permissions';

@Injectable({providedIn: 'root'})
export class PermissionService {
    constructor(private dataService: DataService) {
    }

    has(permission: AdminPermission): boolean {
        const permissions = this.dataService.getUserInfo()?.Permissions || [];
        return permissions.some(value => this.normalize(value) === permission);
    }

    hasAny(permissions: readonly AdminPermission[]): boolean {
        return permissions.some(permission => this.has(permission));
    }

    private normalize(permission: string): string {
        return String(permission || '').trim().toUpperCase();
    }
}
